import React from "react";
import "./_SelectedNecklaces.scss";

const renderRingText = (necklace, memories) => {
  let text = "";
  if (necklace && necklace.fields) {
    text = necklace.fields.title;
  }
  if (memories && memories.length) {
    for (let i = 0; i < memories.length; i++) {
      let materialText = "keltakulta";
      switch (memories[i].material) {
        default:
          break;
        case "white-gold":
          materialText = "valkokulta";
          break;
        case "rose-gold":
          materialText = "ruusukulta";
          break;
      }
      text += `, muisto ${i + 1} ${memories[
        i
      ].memory.fields.title.toLowerCase()} ${materialText}`;
    }
  }
  return <p className="necklaces-text">{text}</p>;
};

export const SelectedNecklaces = ({ title = "", necklace, memories }) => {
  return (
    <div className="selected-necklaces">
      <span className="component-title">{title}</span>
      {renderRingText(necklace, memories)}
    </div>
  );
};
